angular.module('tgaAdmin')
  .controller('ConnectController', [
    '$scope', '$state', 'userService', 'settingsService', 'domainService', 'flashService',
    function (
      $scope, $state, userService, settingsService, domainService, flashService,
    ) {
      // Logout user if already logged in
      userService.logout();

      $scope.data = {
        alerts: [],
        logo: '',
        defaultLogo: './v1/assets/images/logo-black.svg',
      };

      $scope.viewmodel = {
        token: $state.params.token,
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        confirm: null,
        status: null,
      };

      $scope.initialize = function () {
        $scope.loading = true;

        settingsService.getSettings().then((settings) => {
          if (settings.is_sso) {
            $state.go('v1.login');
            return;
          }

          $scope.data.logo = settings.logo || $scope.data.defaultLogo;
        });

        userService.getInvitation($scope.viewmodel.token).then(
          (user) => {
            $scope.viewmodel.first_name = user.first_name;
            $scope.viewmodel.last_name = user.last_name;
            $scope.viewmodel.email = user.email;
            $scope.viewmodel.status = user.status;
            $scope.loading = false;
          },
          (err) => {
            $scope.loading = false;
            $scope.actions.createAlert(`<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${err.message}`, 'danger');
          },
        );
      };

      $scope.actions = {
        submit() {
          $scope.data.alerts = [];

          if ($scope.connectForm.$invalid) {
            return;
          }

          if ($scope.viewmodel.password !== $scope.viewmodel.confirm) {
            return;
          }

          $scope.processing = true;

          userService.acceptInvitation($scope.viewmodel).then(() => {
            flashService.set('<span class="fa fa-check"></span> Account connected.', 'success');
            $state.go('v1.games');
          }, (err) => {
            $scope.processing = false;
            $scope.actions.createAlert(`<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${err.message}`, 'danger');
          });
        },
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
      };

      $scope.initialize();
    },
  ]);
